
const scan_to_brew = () => {
    return "SCAN_TO_BREW";
};

const brew_now = () => {
    return "BREW_NOW"
};

const OperationMode = {
    scan_to_brew,
    brew_now
};

export default OperationMode;
